/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState } from 'react'
import ReactPaginate from 'react-paginate'
import { Col, Row } from 'reactstrap'
import { useHistory } from 'react-router-dom';

const NotificationApprovalContent = ({
    approvalData
}) => {
    let history = useHistory();
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage] = useState(10)

    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage

    const currentPosts = approvalData.slice(indexOfFirstPost, indexOfLastPost)

    return (
        <React.Fragment>
            <Row>
                <table className="table table-bordered table-hover">
                    <thead>
                        <tr>
                            <th>Transaction</th>
                            <th>Transaction No</th>
                            <th>Location</th>
                            <th>Transaction Date</th>
                            <th >Transaction Rule</th>
                            <th style={{ textAlign: "end" }}>Transaction Value</th>


                        </tr>
                    </thead>
                    <tbody>
                        {currentPosts.map((data, index) => {
                            return (
                                <tr key={index}
                                    onClick={() => {

                                        //var url = window.location.href.split("NotificationApproval")[0]
                                        //url = url + `Transaction?${data.rA_TXN_TYPE}&${data.rA_TXN_NO}`
                                        //sessionStorage.setItem("MenuCode", data.rA_TXN_PERMISSION.split("-")[0])
                                        // localStorage.setItem("MenuCode", data.rA_TXN_PERMISSION.split("-")[0])
                                        //redirect to transaction page
                                        //window.location.href = `/Transaction?${data.rA_TXN_TYPE}&${data.rA_TXN_NO}`
                                        // history.push(`${data.rA_URL}?${data.rA_TXN_TYPE}&${data.rA_TXN_NO}`)
                                        // Open the constructed URL in a new tab
                                        window.open(`${data.rA_URL}?${data.rA_TXN_TYPE}&${data.rA_TXN_NO}`, '_blank');
                                    }}
                                >
                                    <td>{"[" + data.rA_TXN_TYPE + "] " + data.tX_DESC}</td>
                                    <td>{data.rA_TXN_NO}</td>
                                    <td>{"[" + data.loC_CODE + "] " + data.loC_DESC}</td>
                                    <td>{data.rA_TXN_DATE.slice(0, 10)}</td>
                                    <td>{data.menuiteM_MENUNAME}</td>
                                    <td style={{ textAlign: "end" }}>{parseFloat(data.rA_TXN_VALUE).toFixed(2)}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </Row>
            <Row>
                <Col md="12">
                    <ReactPaginate
                        previousLabel={'Previous'}
                        nextLabel={'Next'}
                        breakLabel={'...'}
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={Math.ceil(approvalData.length / postsPerPage)}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageClick}
                        forcePage={currentPage - 1}
                        renderOnZeroPageCount={null}
                        activeClassName={'active'}
                        activeLinkClassName={'page-link'}
                        containerClassName={'pagination justify-content-end pagination-sm'}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )

}

export default NotificationApprovalContent